<template>
  <page-view>
    <div slot="pageRight" class="pb90">
      <div class="mt20">
        <!-- 订单列表 -->
        <div class="empty-box bg-white border-radius-4 flex flex-acenter flex-jcenter" style="height:200px;">
          <a-empty />
        </div>
      </div>
    </div>
  </page-view>
</template>

<script>
import { PageView } from '@/components'
export default {
  name: 'IntegralSearch',
  components: { PageView }
}
</script>

<style>

</style>
